<template>
  <v-app :class="prefix">
    <v-app-bar
      height="70"
      app
      color="grey lighten-4"
      elevate-on-scroll>
      <v-container class="mx-auto py-0">
        <v-row class="align-center">
          <!-- <img class="mr-1" :src="require('./assets/logo-pnb.png')" height="50" :alt="apptitle"/> -->
          <router-link :to="{ name: 'Landing' }" class="d-inline-flex">
            <img class="mr-3" :src="require('./assets/logo-pnb.png')" height="55" :alt="apptitle"/>
          </router-link>
          <v-toolbar-title v-show="!$vuetify.breakpoint.xs">
            <div class="title-style-pnb title-style-pnb">{{ apptitle }}</div>
            <div class="title-style-pnb subtitle-style-pnb">{{ appsubtitle }}</div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- public -->
          <div v-if="useremail === ''">
            <v-btn
              small
              class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
              text
              :to="{ name: 'Landing' }"
              exact
              active-class="active-class-style">
              Home
            </v-btn>
            <v-btn
              v-if="false"
              v-show="!$vuetify.breakpoint.smAndDown"
              small
              class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
              text
              :to="{ name: 'About' }"
              exact
              active-class="active-class-style">
              About
            </v-btn>
            <v-btn
              v-show="!$vuetify.breakpoint.smAndDown"
              small
              class="ml-1 px-1 ml-md-1 px-md-2 hover-class-style"
              text
              :to="{ name: 'Contact' }"
              exact
              active-class="active-class-style">
              Contact
            </v-btn>
            <v-divider vertical class="ml-1 ml-md-1" style="height: 16px;"></v-divider>
            <v-btn
              small
              class="ml-1 px-1 ml-md-1 px-md-4 hover-class-style"
              text
              :to="{ name: 'Login' }"
              exact
              active-class="active-class-style">
              Log in
            </v-btn>
            <v-btn
              v-show="!$vuetify.breakpoint.smAndDown"
              small
              depressed
              :color="maincolor"
              class="ml-1 px-1 ml-md-1 px-md-4 white--text"
              :to="{ name: 'Register' }"
              exact
              active-class="active-class-style">
              Sign Up
            </v-btn>
            <v-btn
              v-show="$vuetify.breakpoint.smAndDown"
              icon
              @click.stop="rightDrawer = !rightDrawer">
              <v-icon>menu</v-icon>
            </v-btn>
          </div>
          <!-- private admin -->
          <div v-if="useremail !== ''">
            <!-- profile -->
            <v-btn
              icon
              :to="{ name: btndash }"
              exact>
              <v-icon>mdi-apps</v-icon>
            </v-btn>
            <v-btn
              v-if="userrole === 'dosen'"
              icon
              :to="{ name: 'ProfileDosen' }"
              exact>
              <v-icon>mdi-account</v-icon>
            </v-btn>
            <v-btn
              v-if="userrole === 'mahasiswa'"
              icon
              :to="{ name: 'ProfileMhs' }"
              exact>
              <v-icon>mdi-account</v-icon>
            </v-btn>
            <!-- menu add -->
            <v-menu
              offset-y
              bottom
              left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  exact>
                  <v-icon>mdi-plus-thick</v-icon>
                </v-btn>
              </template>
              <v-list v-if="userrole === 'dosen'">
                <v-list-item
                  v-for="(item, i) in pubadd"
                  :key="i"
                  link
                  :to="item.to"
                  exact>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-if="userrole === 'mahasiswa'">
                <v-list-item
                  v-for="(item, i) in pubaddmhs"
                  :key="i"
                  link
                  :to="item.to"
                  exact>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- menu -->
            <v-btn
              icon
              @click.stop="rightDrawer = !rightDrawer">
              <v-icon>menu</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-navigation-drawer
      v-model="rightDrawer"
      temporary
      fixed
      right>
      <div>
        <v-list>
          <v-list-item
            v-for="(item, i) in menunavshow"
            :key="i"
            link
            :to="item.to"
            exact>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <template v-slot:append v-if="tokenscr">
        <div class="pa-2">
          <v-btn color="error" tile depressed block @click="doLogout">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-footer :color="maincolor" dark>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <div class="headline mb-2">Quick Link</div>
            <div class="mt-5">
              <div
                class="mb-2"
                v-for="(item, i) in pubmenu"
                :key="i">
                <router-link :to="item.to" class="white--text">
                  {{ item.title }}
                </router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">External Link</div>
            <div class="mt-5">
              <div class="mb-2">
                <a href="http://www.pnb.ac.id/" target="_blank" class="white--text">
                  Politeknik Negeri Bali
                </a>
              </div>
              <div class="mb-2">
                <a href="https://www.kemdikbud.go.id/" target="_blank" class="white--text">
                  Kemendikbud-Ristek
                </a>
              </div>
              <div class="mb-2">
                <a href="https://www.vokasi.kemdikbud.go.id/" target="_blank" class="white--text">
                  Ditjen Pendidikan Vokasi
                </a>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">Follow Us</div>
            <div class="mt-5">
              <v-btn
                class="mr-2"
                small
                fab
                outlined>
                <v-icon>
                  mdi-facebook
                </v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                small
                fab
                outlined>
                <v-icon>
                  mdi-instagram
                </v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                small
                fab
                outlined>
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="headline mb-2">{{ apptitle }}</div>
            <div class="mt-5">
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    mdi-map-marker
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  Uluwatu St No.45, Jimbaran, South Kuta, Badung Regency, Bali 80361
                </div>
              </div>
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    phone
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  +62 (0361)701981
                </div>
              </div>
              <div class="mb-2">
                <div class="foot-list-icon float-left">
                  <v-icon>
                    email
                  </v-icon>
                </div>
                <div class="foot-list-content">
                  poltek@pnb.ac.id
                </div>
              </div>
            </div>
          </v-col>
          <v-col
            class="text-center"
            cols="12">
            <v-divider dark></v-divider>
          </v-col>
          <v-col
            class="text-center"
            cols="12">
            Copyright &copy; {{ new Date().getFullYear() }} All rights reserved by <strong> {{ appname }}</strong>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import qs from 'qs';

export default Vue.extend({
  name: 'App',
  components: {
  },
  data: () => ({
    appname: process.env.VUE_APP_NAME,
    apptitle: process.env.VUE_APP_TITLE,
    appsubtitle: process.env.VUE_APP_SUBTITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    darktheme: process.env.VUE_APP_DARK,
    rightDrawer: false,
    notif: [],
    pubadd: [
      {
        title: 'Buat kelas',
        to: { name: 'CreateclassDosen' },
      },
    ],
    pubaddmhs: [
      {
        title: 'Gabung ke kelas',
        to: { name: 'JoinclassMhs' },
      },
    ],
    pubmenu: [
      {
        title: 'Home',
        to: { name: 'Landing' },
      },
      {
        title: 'Contact',
        to: { name: 'Contact' },
      },
      {
        title: 'Log in',
        to: { name: 'Login' },
      },
      {
        title: 'Sign up',
        to: { name: 'Register' },
      },
    ],
    menunav: [
      {
        title: 'Home',
        icon: 'mdi-home',
        to: { name: 'Landing' },
        role: ['dosen', 'mahasiswa', 'public'],
      },
      {
        title: 'Log in',
        icon: 'lock',
        to: { name: 'Login' },
        role: ['public'],
      },
      {
        title: 'Sign up',
        icon: 'mdi-account-plus',
        to: { name: 'Register' },
        role: ['public'],
      },
      {
        title: 'Change Password',
        icon: 'lock_open',
        to: { name: 'Changepassword' },
        role: ['dosen', 'mahasiswa', 'admin'],
      },
      {
        title: 'Permohonan Surat',
        icon: 'mdi-email-outline',
        to: { name: 'SuratListMhs' },
        role: ['mahasiswa-off', 'admin-off'],
      },
      {
        title: 'Contact',
        icon: 'mdi-card-account-mail-outline',
        to: { name: 'Contact' },
        role: ['dosen', 'mahasiswa', 'public'],
      },
    ],
    menunavshow: [],
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    loading: {
      berita: false,
    },
    btndash: 'ListclassMhs',
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  mounted() {
    // check tokensrc
    if (this.tokenscr && this.tokenscr !== '') {
      this.checkTokenscr();
    }
    // update menu if not watch
    this.menuByRole();
    // notif
    // this.getNotifikasi();
  },
  methods: {
    menuByRole() {
      // dashboard btn
      if (this.userrole === 'dosen') {
        this.btndash = 'ListclassDosen';
      } else if (this.userrole === 'mahasiswa') {
        this.btndash = 'ListclassMhs';
      } else {
        this.btndash = 'ListclassMhs';
      }
      // menu nav
      this.menunavshow = [];
      // console.log(this.userrole);
      for (const row of this.menunav) {
        if (this.userrole && this.userrole !== '') {
          if (row.role.indexOf(this.userrole) >= 0) {
            this.menunavshow.push(row);
          }
        } else {
          if (row.role.indexOf('public') >= 0) {
            this.menunavshow.push(row);
          }
        }
      }
    },
    getNotifikasi() {
      this.notif = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/surat/',
            {
              params: {
                status: 'request',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.notif = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkTokenscr() {
      this.axios
        .post(
          this.api + '/api/checktoken',
          qs.stringify(
            {
              token: this.tokenscr,
            },
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.tokenscr,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            if (resdata.error === true) {
              this.doLogout();
            }
          }
        })
        .catch((error) => {
          this.doLogout();
        });
    },
    doLogout() {
      this.$store.commit('AUTH_LOGOUT');
      this.$router.push({ name: 'Login' });
    },
  },
  watch: {
    userrole(val) {
      this.menuByRole();
    },
    tokenscr(val) {
      // this.getNotifikasi();
    },
  },
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $main-color: #216185;
  $main-font: 'Nunito';
  $gray-table: rgba(0, 0, 0, 0.12);
  .width100{
    width: 100% !important;
  }
  .hidestyle{
    opacity: 0.5;
  }
  .limit-height-scroll{
    max-height: 800px;
    overflow-y: auto;
  }
  .limit-height500-scroll{
    max-height: 500px;
    overflow-y: auto;
  }
  .title-style-pnb{
    font-family: $main-font !important;
    color: $main-color !important;
    font-weight: bold;
    line-height: normal !important;
  }
  .title-style-pnb{
    font-size: 26px;
  }
  .subtitle-style-pnb{
    font-size: 14px;
  }
  .main-style-slide{
    color: $main-color !important;
  }
  .foot-list-icon{
    width: 40px;
  }
  .foot-list-content{
    display: table-cell;
    vertical-align: top;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .class-cursor{
    cursor: pointer;
  }
  // table scroll
  .tblscr-cont{
    overflow:auto;
    width:100%;
    height:450px;
  }
  table.tblscr-style{
    border-spacing: 0px;
    table-layout: fixed;
    // width:100%;
    tr {
      th {
        min-width: 150px;
        border-top: thin solid $gray-table;
        border-bottom: thin solid $gray-table;
        border-right: thin solid $gray-table;
        padding: 5px 10px;
        background-color:white;
      }
      td {
        border-bottom: thin solid $gray-table;
        border-right: thin solid $gray-table;
        padding: 5px 10px;
      }
    }
    td:first-child, th:first-child, td:nth-child(2) {
      position:sticky;
      left:0;
      z-index:1;
      background-color:white;
      border-left: thin solid $gray-table;
      color: black;
    }
    td:nth-child(2), th:nth-child(2) {
      left: 150px;
      border-left: none;
    }
    thead tr th {
      position:sticky;
      top:0;
      z-index:2;
    }
    th:first-child, th:nth-child(2){
      z-index:3;
    }
    tr:hover {
      background-color: #eeeeee;
    }
  }
</style>
